import sasClass from './sas.class'

const sas = {}

sas.push = (props, events) => {
    const object = new sasClass(props, events)
    
    window.sas.cmd.push(function () {
        window.sas.call("std", object.props, object.events);
    })
}

sas.domInjection = (smartUrl, prebidUrl) => {
    if (smartUrl) {
        let script = document.createElement('script');
        let node = document.getElementsByTagName('body')[0];

        script.type = 'text/javascript';
        script.async = true;
        script.defer = false;
        script.src = smartUrl;
        node.appendChild(script);
    }

    if (prebidUrl) {
        let script = document.createElement('script');
        let node = document.getElementsByTagName('body')[0];
        script.type = 'text/javascript';
        script.async = true;
        script.defer = false;
        script.src = prebidUrl;
        node.appendChild(script);
    }
}

export default sas